import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const ArrowIcon = ({ isOpen }) => (
  isOpen ? (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-4">
      <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"/>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-4">
      <path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
    </svg>
  )
);
const routeArray={'/member/list':'member',
  '/member/create':'member',
  '/member/collection':'member',
  '/income':'income',
  '/expense/daily':'expense',
  '/invest/borrower':'invest',
  '/invest/local':'invest',
  '/invest/other':'invest',
  '/profit-loss/disbursement':'profit-loss',
  '/finance/transaction':'finance'
};

const Sidebar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState();
  const location=useLocation();

  const toggleDropdown = (e) => {
    
    if (e===isDropdownOpen) {  
      setIsDropdownOpen(false);
    }else{
      setIsDropdownOpen(e);
    }
  };
  const isActiveLink = (path) => location.pathname === path ? "bg-sky-500/50" : "";

  useEffect(()=>{
      setIsDropdownOpen(routeArray[location.pathname]);
      toggleDropdown(routeArray[location.pathname])
      
  },[]);
  
  return (
    <div className="h-screen pb-[85px] text-black overflow-y-auto no-scrollbar scrollbar-hide">
      <nav className="pr-2">
        <Link to="/" className={`block py-2.5 mb-2 px-4 rounded transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/")}`}>
          Dashboard
        </Link>
        <div>
          <button
            onClick={()=>toggleDropdown('member')}
            className="w-full text-left block py-2.5 px-4 rounded transition duration-200 hover:bg-sky-500/50 flex flex-row items-center"
          >
            <span className="grow">Member</span>
            <ArrowIcon isOpen={isDropdownOpen === 'member'} />
          </button>

          {isDropdownOpen ==='member' && (
            <>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/member/list" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/member/list")}`}>
                  - Member List
                </Link>
              </div>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/member/collection" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/member/collection")}`}>
                  - Collection
                </Link>
              </div>
            </>
          )}
        </div>

        <div>
          <button
            onClick={()=>toggleDropdown('invest')}
            className="w-full text-left block py-2.5 px-4 rounded transition duration-200 hover:bg-sky-500/50 flex flex-row items-center	"
          >
            <span className="grow">Invest</span>
            
            <ArrowIcon isOpen={isDropdownOpen === 'invest'} />
          </button>
          {isDropdownOpen ==='invest' && (
            <>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/invest/borrower" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/invest/borrower")}`}>
                  Borrower List
                </Link>
              </div>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/invest/local" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/invest/local")}`}>
                  Local Invest
                </Link>
              </div>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/invest/other" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/invest/other")}`}>
                  Other Invest
                </Link>
              </div>
            </>
          )}
        </div>
          
        <div>
          <button
            onClick={()=>toggleDropdown('income')}
            className="w-full text-left block py-2.5 px-4 rounded transition duration-200 hover:bg-sky-500/50 flex flex-row items-center	"
          >
            <span className="grow">Income</span>
            <ArrowIcon isOpen={isDropdownOpen === 'income'} />
          </button>
          {isDropdownOpen ==='income' && (
            <>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/income" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/income")}`}>
                Income List
                </Link>
              </div>
            </>
          )}
        </div>
        
        <div>
          <button
            onClick={()=>toggleDropdown('finance')}
            className="w-full text-left block py-2.5 px-4 rounded transition duration-200 hover:bg-sky-500/50 flex flex-row items-center	"
          >
            <span className="grow">Finance</span>
            <ArrowIcon isOpen={isDropdownOpen === 'finance'} />
          </button>
          {isDropdownOpen ==='finance' && (
            <>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/finance/transaction" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/finance/transaction")}`}>
                  Transaction
                </Link>
              </div>
            </>
          )}
        </div>
        <div>
          <button
            onClick={()=>toggleDropdown('profit-loss')}
            className="w-full text-left block py-2.5 px-4 rounded transition duration-200 hover:bg-sky-500/50 flex flex-row items-center	"
          >
            <span className="grow">Profit/Loss</span>
            <ArrowIcon isOpen={isDropdownOpen === 'profit-loss'} />
          </button>
          {isDropdownOpen ==='profit-loss' && (
            <>
              <div className="left-0 pl-2 w-full rounded mt-2 z-10">
                <Link to="/profit-loss/disbursement" className={`block py-2.5 px-4 transition duration-200 hover:bg-sky-500/50 ${isActiveLink("/profit-loss/disbursement")}`}>
                  Profit Disbursement
                </Link>
              </div>
            </>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
